'use strict';

const jQuery = require('jquery');

const Container = require('./../../../core/container');
const Mediator = require('./../../../core/mediator');

const SaveManager = require('./../component/SaveManager');
const menuMobile = require('./../../../services/structure/menu/mobile');
const Rte = require('./../../../services/rte');
const TextPlaceholder = require('./../service/textPlaceholder');

let currentInterval = null;

module.exports.onPressEdit = function(data) {
    let content = data.params.content;
    let $content;

    if (content.isRteEditable()) {
        $content = content.$.find('[data-cloud-rte]');

        if (!$content.length) {
            $content = content.$;
        }

        if ($content.attr('data-cloud-rte')) {
            let rteConfig = {
                '$element': $content,
                '$container': Container.get('$toolbar'),
                'content': content,
            };

            content.currentRteValue = $content.html();

            content.$.off('touchstart.menu_close MSPointerDown.menu_close');

            content.editable = false;

            menuMobile.close();

            jQuery('body').append(jQuery('<div class="cloud-overlay"></div>'));

            content.$.addClass('cloud-highlight');

            if (content.$.css('background-color') === 'rgba(0, 0, 0, 0)') {
                content.$.addClass('cloud-highlight-bg');
            }

            jQuery('.cloud-menu').addClass('d-none');

            Container.get('$siteWrapper').addClass('rte');

            if (Container.get('isMobile')) {
                jQuery('body').on('touchstart.rte MSPointerDown.rte', function(e) {
                    let $target = jQuery(e.target);

                    if (!$target.parents('.bb-content:first').is(content.$) && !$target.is(content.$)) {
                        Mediator.publish('before:rte:destroy', rteConfig);
                        Mediator.publish('after:rte:destroy', rteConfig);
                        jQuery('body').off('touchstart.rte MSPointerDown.rte');
                    }
                });
            }

            $content.on('touchend.rte MSPointerUp.rte', function(e) {
                if (!$content.hasClass('cke_editable')) {
                    jQuery('body').off('touchstart.rte MSPointerDown.rte');

                    Rte.create(rteConfig);
                }
            });
        }
    }
};

module.exports.afterRteCreate = function(config) {
    let scrollTimeout;

    jQuery(document).on('scroll.rte', function(currentConfig) {
        let $rte = jQuery('.cke');

        $rte.css('opacity', '0');

        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(function() {
            $rte.css('position', 'absolute');
            $rte.css('top', window.pageYOffset);
            $rte.css('opacity', '1');
        }, 150);
    }.bind(undefined, config));

    TextPlaceholder.unApplyToElement(config.$element);
};

module.exports.beforeRteDestroy = function(config) {
    config.content.editable = true;
};

module.exports.afterRteDestroy = function(config) {
    let content = config.content;

    jQuery(window).off('touchend.rte');
    jQuery(document).off('scroll.rte');
    config.$element.off('touchend.rte MSPointerUp.rte');
    clearInterval(currentInterval);

    jQuery('.cloud-menu').removeClass('d-none');

    jQuery('.cloud-rte-mobile').remove();

    Container.get('$siteWrapper').removeClass('rte');

    content.$.removeClass('cloud-highlight cloud-highlight-bg');

    jQuery('.cloud-overlay').remove();

    if (content && content.currentRteValue !== config.$element.html()) {
        content.addElement('value', config.$element.html());

        SaveManager.save();
    }

    TextPlaceholder.globalApply();
};
